import { Component, OnInit, Input, Output, EventEmitter, inject } from '@angular/core';
import { ServiceModel } from '../../../../../../store/self-diagnostic/service-catalog/model';
import { UserModel } from '../../../../../../store/user/model';
import { AppConstants } from '../../../../../../core/constants/app-constants';
import { UserFacade } from '../../../../../../store/user/facade';

@Component({
  selector: 'app-service-catalog-details',
  templateUrl: './service-catalog-details.component.html',
  styleUrls: ['./service-catalog-details.component.scss'],
  standalone: false,
})
export class ServiceCatalogDetailsComponent implements OnInit {
  private userFacade = inject(UserFacade);

  @Input('service') public srcService: ServiceModel;
  public service: ServiceModel;
  @Output('onSave') public onSave$ = new EventEmitter<ServiceModel>();

  public user: UserModel;
  public isLanguageUa: boolean;

  public additionalFields: string[] = [];
  public keyWords: string[] = [];

  ngOnInit(): void {
    // Get current language
    this.userFacade.selected().subscribe(user => {
      this.user = { ...user };

      this.isLanguageUa = !this.user?.language || this.user?.language == AppConstants.LANGUAGE_UK;
    });

    this.service = { ...this.srcService };
    this.mapKeyWords();
  }

  public save() {
    this.service.keyWords = this.keyWords.join(', ');

    this.onSave$.emit(this.service);
  }

  private mapKeyWords() {
    if (this.service.keyWords) {
      this.keyWords = this.service.keyWords.split(',').map(key => key.trim().toLowerCase());
    }
  }
}
